<ng-container *ngIf="currentHandData && currentHandCards">
	<app-hand-display
		[cardsArray]="currentHandCards"
		[handData]="currentHandData">
	</app-hand-display>
</ng-container>
<app-pagination [totalPages]="totalPages"></app-pagination>
